import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}quotes`;

export interface EditQuoteTaskCommandArgs {
  quoteId: string;
  name: string;
  partsPrice?: number;
  laborPrice?: number;
  bundlePrice?: number;
}

export const editQuoteTaskRequest = (
  payload: EditQuoteTaskCommandArgs,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.quoteId}/items`,
  config: {
    method: SUPPORTED_METHODS.POST,
    json:
      payload.bundlePrice === 0 || payload.bundlePrice === undefined
        ? {
            name: payload.name,
            partsPrice: payload.partsPrice,
            laborPrice: payload.laborPrice,
          }
        : {
            name: payload.name,
            bundlePrice: payload.bundlePrice,
          },
  },
});

export const editQuoteTaskCommand = async (
  payload: EditQuoteTaskCommandArgs,
): Promise<BackResponse<string> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<string>>(
      editQuoteTaskRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
